import React from 'react';
import { Button, Paper, Collapse } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import AddIcon from '@material-ui/icons/Add';
import Spreadsheet from 'react-spreadsheet';
import CircularProgress from '@material-ui/core/CircularProgress';
import { instanceAxios } from '../../InstanceAxios';
import environment from '../../environment';
import { XMEI_PRIMARY_COLOR } from '../../consts/common';

const numberToReal = (numero) => {
  if (numero) {
    var numero = numero.toFixed(2).split('.');
    numero[0] = `R$ ${numero[0].split(/(?=(?:...)*$)/).join('.')}`;
    return numero.join(',');
  }
};

const realToNumber = (number) => {
  if (number) {
    return parseFloat(
      number.replace('R$', '').replace(/\./g, '').replace(/\,/g, '.')
    );
  }
  return 0;
};

function Receita() {
  const [sheetData, setSheetData] = React.useState([]);
  const [isAlert, setIsAlert] = React.useState(false);
  const [tipoAlert, setTipoAlert] = React.useState('');
  const [message, setMessage] = React.useState('');
  const [ready, setReady] = React.useState(true);

  const data = [
    [
      { value: '' }, // Nome
      { value: '' }, // CPF/CNPJ
      { value: '' }, // Email
      { value: '' }, // Valor
      { value: '' }, // Descrição
      { value: '' }, // CEP
      { value: '' }, // Logradouro
      { value: '' }, // Número
      { value: '' }, // Complemento
      { value: '' }, // Bairro
      { value: '' }, // Estado
      { value: '' }, // Cidade
    ],
  ];

  React.useEffect(() => {
    addRows();
  }, []);

  const addRows = async () => {
    const arrayDataSheet = [];
    for (let i = 0; i < 10; i++) {
      arrayDataSheet.push(data[0]);
    }
    setSheetData(arrayDataSheet);
  };

  const handleSubmit = async () => {
    setReady(false);
    setIsAlert(false);
    // Limpando linhas vazias
    const arrayFilter = sheetData.filter(
      (item) =>
        item[0].value !== '' ||
        item[1].value !== '' ||
        item[2].value !== '' ||
        item[3].value !== '' ||
        item[4].value !== '' ||
        item[5].value !== '' ||
        item[6].value !== '' ||
        item[7].value !== '' ||
        item[8].value !== '' ||
        item[9].value !== '' ||
        item[10].value !== '' ||
        item[11].value !== ''
    );
    if (!arrayFilter.length) {
      setTipoAlert('warning');
      setMessage(
        'Todos campos obrigatórios devem estar preenchidos, você pode identificar quais são eles através do *'
      );
      setIsAlert(true);
      setReady(true);
      return;
    }
    // Validando campos obrigatorios
    const arrayItemsWithoutMandatoryData = arrayFilter.filter(
      (item) =>
        item[0].value === '' || item[3].value === '' || item[4].value === ''
    );
    // Existe linhas faltando dados obrigatorios
    if (arrayItemsWithoutMandatoryData.length > 0) {
      // Message
      setTipoAlert('warning');
      setMessage(
        'Todos campos obrigatórios devem estar preenchidos, você pode identificar quais são eles através do *'
      );
      setIsAlert(true);
      setReady(true);
      return;
    }

    const arrayItemsWithWrongTypes = arrayFilter.filter((item) => {
      const regexOnlyNumbers = /^[0-9\b]+$/;
      const cpf_cnpj = item[1].value.replace(/\./g, '').replace('-', '');
      const item_value = item[3].value.replace(/\./g, '').replace(/,/g, '');

      if (
        (!regexOnlyNumbers.test(cpf_cnpj) && cpf_cnpj !== '') ||
        !regexOnlyNumbers.test(item_value)
      ) {
        return item;
      }
    });
    // Existe linhas com letras em cpf ou em valor
    if (arrayItemsWithWrongTypes.length > 0) {
      // Message
      setTipoAlert('warning');
      setMessage(
        'Verifique os campos de cnpj e valor ambos devem conter somente números, pontos, vírgulas'
      );
      setIsAlert(true);
      setReady(true);
      return;
    }
    // Pode mandar pra api então
    const arrayWithItemsFormat = arrayFilter.map((item) => {
      return {
        descricao: item[4].value,
        valor: realToNumber(item[3].value),
        nome: item[0].value,
        cpf_cnpj: item[1].value.replace(/\./g, '').replace('-', ''),
        email: item[2].value,
        cep: item[5].value,
        logradouro: item[6].value,
        numero: item[7].value,
        complemento: item[8].value,
        bairro: item[9].value,
        cidade: item[11].value,
        estado: item[10].value,
      };
    });
    await instanceAxios(localStorage.getItem('toobiauth'))
      .post(`/salvarLancamentoReceitaPortal`, {
        lancamentos: arrayWithItemsFormat,
      })
      .then((res) => {
        addRows();
        setMessage(res.data.message);
        const tipoAlert =
          res.data.errosLancamentos.length === 0 ? 'success' : 'warning';
        setTipoAlert(tipoAlert);
        setIsAlert(true);
        setReady(true);
      })
      .catch((err) => {
        console.log(err);
        setTipoAlert('error');
        setMessage('Erro Inesperado,tente novamente mais tarde!!!');
        setIsAlert(true);
        setReady(true);
      });
  };

  return (
    <Paper
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 15,
        margin: 15,
      }}
      elevation={10}
    >
      {ready ? (
        <>
          {isAlert ? (
            <Alert
              variant="filled"
              severity={tipoAlert}
              action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={() => {
                    setIsAlert(false);
                  }}
                >
                  <CloseIcon fontSize="inherit" />
                </IconButton>
              }
              style={{ marginBottom: 10 }}
            >
              {message}
            </Alert>
          ) : (
            <h1
              style={{
                marginTop: 10,
                marginBottom: 30,
                fontSize: 28,
                textAlign: 'center',
                color: '#000',
              }}
            >
              Lançamento de Receita
            </h1>
          )}
          <Spreadsheet
            data={sheetData}
            columnLabels={[
              'Nome do Cliente *',
              'CPF/CNPJ Cliente',
              'Email',
              'Valor *',
              'Descrição *',
              'CEP',
              'Logradouro',
              'Número',
              'Complemento',
              'Bairro',
              'Estado',
              'Cidade',
            ]}
            onChange={(e) => setSheetData(e)}
            hideRowIndicators
          />
          <Button
            variant="text"
            style={{
              width: '25%',
              marginTop: 15,
              backgroundColor: XMEI_PRIMARY_COLOR,
              color: '#FFF',
              height: 25,
            }}
            onClick={() => {
              const arrayDataSheet = [];
              for (let i = 0; i < 10; i++) {
                arrayDataSheet.push(data[0]);
              }
              const array = [...sheetData, ...arrayDataSheet];
              setSheetData(array);
            }}
          >
            Adicionar linhas
          </Button>
          <Button
            variant="contained"
            style={{
              width: '40%',
              marginTop: 30,
              marginBottom: 15,
              backgroundColor: XMEI_PRIMARY_COLOR,
              color: '#FFF',
            }}
            onClick={handleSubmit}
          >
            Salvar
          </Button>
        </>
      ) : (
        <CircularProgress style={{ marginLeft: '50%' }} />
      )}
    </Paper>
  );
}

export default Receita;
